import React from "react";
import { Card, Typography, Row, Col, Input } from "antd";
import "./EducentreDetails.less";
import { useSelector } from "react-redux";
import { EducentreDetailCard } from "../../../component";
import { useNavigate } from "react-router-dom";
import { useGetCoachingBatchesQuery } from "../../../redux/services/batches";
import { useParams } from "react-router-dom";

const { Title, Text } = Typography;

const EducentreDetails = () => {
  const { currentCoachingName, setCurrentCoachingLogo } = useSelector(
    (state) => state.auth
  );
  const { coaching_id } = useParams();
  const navigate = useNavigate();

  console.log("coaching_id", coaching_id);

  const { data: coachingBatches, isLoading: batchLoading } =
    useGetCoachingBatchesQuery(coaching_id);
  const handleCardClick = (coaching_id) => {
    navigate(`/educentre/${coaching_id}/courses`);
  };

  const data = [
    {
      teacher: "Sudhanshu Shekhar",
      subject: "Chemistry",
      schedule: "Mon, Wed, Fri",
      mode: "Offline",
      batchSize: "50",
      availableSeats: "30",
    },
    {
      teacher: "Sudhanshu Shekhar",
      subject: "Chemistry",
      schedule: "Mon, Wed, Fri",
      mode: "Offline",
      batchSize: "50",
      availableSeats: "30",
    },
  ];

  return (
    <div className='educentre-detail-container'>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <img src={setCurrentCoachingLogo} />
        <span>
          {currentCoachingName ? currentCoachingName : "Coaching Name"}
        </span>
      </div>
      <Title className='title' style={{ marginBottom: "20px" }}>
        List of Batches
      </Title>
      {data.map((item, index) => (
        <EducentreDetailCard
          key={index}
          {...item}
          onClick={() => handleCardClick(item.coaching_id)}
        />
      ))}
    </div>
  );
};

export default EducentreDetails;
